var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.328125,
    width: 26,
    height: 26,
    rx: 8,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10251_85861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.82812V8.22813C16.5 7.38805 16.5 6.96801 16.3365 6.64714C16.1927 6.3649 15.9632 6.13543 15.681 5.99162C15.3601 5.82812 14.9401 5.82812 14.1 5.82812H12.9C12.0599 5.82812 11.6399 5.82812 11.319 5.99162C11.0368 6.13543 10.8073 6.3649 10.6635 6.64714C10.5 6.96801 10.5 7.38805 10.5 8.22813V8.82812M6.75 8.82812H20.25M18.75 8.82812V17.2281C18.75 18.4882 18.75 19.1183 18.5048 19.5996C18.289 20.023 17.9448 20.3672 17.5215 20.5829C17.0402 20.8281 16.4101 20.8281 15.15 20.8281H11.85C10.5899 20.8281 9.95982 20.8281 9.47852 20.5829C9.05516 20.3672 8.71095 20.023 8.49524 19.5996C8.25 19.1183 8.25 18.4882 8.25 17.2281V8.82812",
    stroke: "#F04438",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10251_85861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(4.5 4.32812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashDelete);
export default __webpack_public_path__ + "static/media/trash_delete.e7e34f2fe5747216b0a01b6c26186733.svg";
export { ForwardRef as ReactComponent };